import { render, staticRenderFns } from "./OrdenanzasView.vue?vue&type=template&id=b56d9f40&"
import script from "./OrdenanzasView.vue?vue&type=script&lang=ts&"
export * from "./OrdenanzasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports